import Tetris from './Tetris.vue';
export default Tetris;
